import { IModalProps, IModalStore } from '../models/Base'

export enum AssessTypeEnum {
  self = 1,
  spacial = 2,
  job = 3,
  stat = 4,
  annouce = 5
}

export enum JobCategoryEnum {
  SVNH,
  Training,
  Holistic,
}

export enum categoryEnum {
  Late,
  Leave,
  Stat,
  Issue,
  Income,
  NumberOfCase,
  WorkingHour,
}

export type GlobalModalContextType = {
  showModal: (modalProps?: IModalProps, onClickCallBack?: (type: 'ok' | 'cancel') => void) => void
  hideModal: () => void
  store: IModalStore
}



export const SystemDateDisplayFormat = 'DD/MM/YYYY'
export const SystemDateSaveFormat = 'YYYY-MM-DD'
export const SystemTimeFormat = 'hh:mm A'
export const SystemDateLongDisplay = 'DD/MM/YYYY hh:ss A'

export enum DynamicFieldTypeEnum {
  RegisterPatient = 0,
  RegisterTherapist = 1,
  Note = 2,
  Satisfaction = 3,
  SatisfactionPatient = 4,
}

export enum NoteTypeEnum {
  FirstAssesmentNote = 46,
  ReAssesmentNote = 47,
  ProgressNote = 48,
  SummaryReport = 49,
  DoctorOrder = 53,
}

export enum SearchPageModeEnum {
  Default = 0,
  PatientPage = 1,
  LookupPage = 2,
}

export const API_IMG_AVATR = process.env.REACT_APP_API_URL + '/commons/files/avatar'
export const API_IMG_SPECIAL_FILE = process.env.REACT_APP_API_URL + '/commons/files/img-special'
export const API_IMG_ANNOUNCE_FILE = process.env.REACT_APP_API_URL + '/commons/files/img-announce'

export const Pattern = {
  Token: /^(?!0\d)\d{0,18}(?:[.]\d{0,18})?$/,
  Money: /^[+-]?\d*(?:[.,]\d*)?$/,
  Number: /^(?!0\d)[0-9]*$/,
  NumberDot: /^\d*(?:[.]\d*)?$/,
  Number2Digit: /^(?!0\d)\d{0,18}(?:[.]\d{0,2})?$/,
  Number2DigitMinus:/^[+-]?(?!0\d)\d{0,18}(?:[.]\d{0,2})?$/,
}

export const PackageCondition = {
  FREE1: 'FREE1',
  DISCOUNT10: 'DISCOUNT10',
}


export type ImageTypeCode = 'avatar' | 'img-special' | 'img-announce'
export enum KPIStatus {
  Temporary,
  Completed
}

export enum AnnouncementTypeEnum {
  Acknowledge,
  Question
}

export enum AnnounceStatusEnum {
  New ,
  Readed ,
  Complete ,
  InComplete ,
  Fail ,
  Expired
}

export enum SeasonStatusEnum {
  New,
  Started,
  Ended,
  InActive  
}

export enum RoleCodeEnum {
  Employee,
  Admin
}